import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "common/style/index.scss";
import toast from "@/components/toast";
import "swiper/dist/css/swiper.css";
import lang from "./config/lang/index";
// import "./theme/08/theme.scss";
Vue.config.productionTip = false;
Vue.use(VueAwesomeSwiper);
Vue.use(toast);
Vue.prototype.$lang = lang;
Vue.prototype.$langEnv = window.lang_env || "cn";
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
